import { useEffect, useState } from "react";
import { Table, Button, Modal, Form, Input, InputNumber, message } from "antd";
import { getAllTagTypes, addTagType, updateTagType, deleteTagType } from "../services/tagService";
import { toast } from 'react-toastify';

const TagTypes = () => {
  const [tagTypes, setTagTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [editingTagType, setEditingTagType] = useState(null);
  const [deletingTagType, setDeletingTagType] = useState(null);
  const [form] = Form.useForm();

  const fetchTagTypes = async () => {
    setLoading(true);
    try {
      const response = await getAllTagTypes();
      setTagTypes(response.Data.Items || []);
    } catch {
      message.error("Etiket tipleri alınamadı.");
    } finally {
      setLoading(false);
    }
  };

  const handleAddOrUpdate = async (values) => {
    try {
      let response;
      if (editingTagType) {
        response = await updateTagType({ ...editingTagType, ...values });
      } else {
        response = await addTagType(values);
      }

      if (response?.Status) {
        toast.success(response?.Message || response?.MessageCode || "İşlem başarılı.");
      } else {
        toast.error(response?.Message || "İşlem başarısız.");
      }

      fetchTagTypes();
      setIsModalOpen(false);
      form.resetFields();
      setEditingTagType(null);
    } catch (error) {
      const msg = error?.response?.data?.Message || "İşlem sırasında hata oluştu.";
      toast.error(msg);
    }
  };

  const handleDelete = async (id) => {
    try {
      const response = await deleteTagType(id);
      if (response?.Status) {
        toast.success(response?.Message || response?.MessageCode || "Silme işlemi başarılı.");
        fetchTagTypes();
      } else {
        toast.error(response?.Message || "Silme işlemi başarısız.");
      }
    } catch (error) {
      const msg = error?.response?.data?.Message || "Silme sırasında hata oluştu.";
      toast.error(msg);
    } finally {
      setIsDeleteModalOpen(false);
      setDeletingTagType(null);
    }
  };

  useEffect(() => {
    fetchTagTypes();
  }, []);

  return (
    <div>
      <h2>Etiket Tipleri</h2>
      <Button type="primary" onClick={() => setIsModalOpen(true)} style={{ marginBottom: 16 }}>
        Yeni Etiket Tipi Ekle
      </Button>
      <Table
        rowKey="id"
        loading={loading}
        dataSource={tagTypes}
        columns={[
          { title: "Ad", dataIndex: "name" },
          { title: "Açıklama", dataIndex: "description" },
          { 
            title: "Seçim Limiti", 
            dataIndex: "selectionLimit",
            render: (limit) => limit || "Sınırsız"
          },
          {
            title: "İşlem",
            width: 200,
            render: (text, record) => (
              <>
                <Button
                  onClick={() => {
                    setEditingTagType(record);
                    form.setFieldsValue(record);
                    setIsModalOpen(true);
                  }}
                  style={{ marginRight: 8 }}
                >
                  Güncelle
                </Button>
                <Button
                  danger
                  onClick={() => {
                    setDeletingTagType(record);
                    setIsDeleteModalOpen(true);
                  }}
                >
                  Sil
                </Button>
              </>
            ),
          },
        ]}
      />

      {/* Ekle / Güncelle Modal */}
      <Modal
        title={editingTagType ? "Etiket Tipi Güncelle" : "Etiket Tipi Ekle"}
        open={isModalOpen}
        onCancel={() => {
          setIsModalOpen(false);
          setEditingTagType(null);
          form.resetFields();
        }}
        onOk={() => form.submit()}
      >
        <Form form={form} onFinish={handleAddOrUpdate} layout="vertical">
          <Form.Item 
            name="name" 
            label="Etiket Tipi Adı" 
            rules={[{ required: true, message: "Etiket tipi adı gereklidir!" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item name="description" label="Açıklama">
            <Input.TextArea rows={3} />
          </Form.Item>
          <Form.Item 
            name="selectionLimit" 
            label="Seçim Limiti" 
            tooltip="Bu etiket tipinden kaç adet seçilebileceğini belirler. Boş bırakılırsa sınırsız seçim yapılabilir."
          >
            <InputNumber 
              min={0} 
              placeholder="Sınırsız" 
              style={{ width: '100%' }}
            />
          </Form.Item>
        </Form>
      </Modal>

      {/* Silme Onay Modalı */}
      <Modal
        title="Silme işlemini onaylıyor musunuz?"
        open={isDeleteModalOpen}
        onCancel={() => {
          setIsDeleteModalOpen(false);
          setDeletingTagType(null);
        }}
        onOk={() => {
          if (deletingTagType) {
            handleDelete(deletingTagType.id);
          }
        }}
        okText="Evet, Sil"
        okType="danger"
        cancelText="Vazgeç"
      >
        <p>
          "{deletingTagType?.name}" adlı etiket tipi silinecek. Bu işlemi onaylıyor musunuz?
        </p>
      </Modal>
    </div>
  );
};

export default TagTypes;